const ProgressBar = ({ order }) => {
  const steps = ["Order Placed", "Preparing", "On the Way", "Delivered"];

  return (
      <div className="d-flex justify-content-center mb-3">
       {[1, 2, 3, 4].map((bar, idx) => {
        const isActive = order.progress >= (idx + 1) * 25;
        return (
          <div
            key={idx}
            className={`mx-2 transition-all duration-300 ease-in-out ${
              isActive ? "hover:scale-105" : ""
            }`}
             style={{
                height: "14px",
                width: "70px",
                borderRadius: "10px",
                boxShadow: isActive
                  ? "0 4px 8px rgba(0, 0, 0, 0.3)" // Active bar shadow
                  : "0 2px 4px rgba(0, 0, 0, 0.1)", // Inactive bar shadow
                backgroundColor: isActive
                  ? "#4A90E2" // Solid blue for active bars
                  : "#D9D9D9", // Light gray for inactive bars
                transition: "transform 0.3s ease, background-color 0.3s ease",
              }}
          ></div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
